import { render, staticRenderFns } from "./BlockType117.vue?vue&type=template&id=46086128&scoped=true"
import script from "./BlockType117.vue?vue&type=script&lang=ts"
export * from "./BlockType117.vue?vue&type=script&lang=ts"
import style0 from "./BlockType117.vue?vue&type=style&index=0&id=46086128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46086128",
  null
  
)

export default component.exports